import { render, staticRenderFns } from "./HeaderTitlePage.vue?vue&type=template&id=57554ecf&scoped=true&"
import script from "./HeaderTitlePage.vue?vue&type=script&lang=js&"
export * from "./HeaderTitlePage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitlePage.vue?vue&type=style&index=0&id=57554ecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57554ecf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VBadge,VBtn,VIcon})
